import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TestAccession } from '../../models/TestAccession';
import { Source } from '../../models/Source';
import { CumulativeComponent } from '../result-cumulative/result-cumulative.component';
//import 'rxjs/add/operator/toPromise';
import { CumulativeQuery } from '../../models/CumulativeQuery';
import { AuthService } from '../../services/auth.service';
import { DatePipe } from '@angular/common';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'result-details',
  standalone: true,
  imports: [
    DatePipe,
    CommonModule,
    CumulativeComponent
  ],
  templateUrl: './result-details.component.html',
  styleUrl: './result-details.component.css'
})

export class ResultDetailsComponent implements OnInit {

  testAccession: TestAccession | undefined = new TestAccession();
  UserSource: Source = new Source();
  @Output() onHide = new EventEmitter<any>();
  @Input() set _testAccession(_testAccession: TestAccession | undefined) {
    //console.log("testAccession setter", _testAccession)
    this.testAccession = _testAccession;// || undefined;
    this.cumShouldBeEmpty = true;
    this.cumClicked = false;
  }

  //@Input() set resultDetails(results: TestAccession[]) {}


  Id: string ="";
  cumClicked = false;
  cumulativeQuery: CumulativeQuery = new CumulativeQuery();
  cumShouldBeEmpty = false;

  constructor(private authService: AuthService) { }

  cumViewClicked(testCode: string) {
    this.cumClicked = true;
    this.cumShouldBeEmpty = false;
    console.log("loading ", this.testAccession, testCode);
    this.cumulativeQuery = { surname: (this.testAccession as TestAccession).Surname, forename: (this.testAccession as TestAccession).ForeName, dob: (this.testAccession as TestAccession).Dob.toString(), testCode: testCode };
  }

  hideCum(event: any) {
    this.cumClicked = false;
  }

  raiseHide(event: any) {
    this.onHide.emit(event);
  }

  print(event: any) {
    window.print();
  }

  getAge(): number {

    let a = (this.testAccession?.SampleDate || new Date());
    let b = (this.testAccession?.Dob || new Date());
    var msDiff = new Date(a).getTime() - new Date(b).getTime()
    //console.log(msDiff);
    return Math.floor(msDiff / 31556952000);
  }

  downloadXML(testAccession: TestAccession) {
    var dataStr = this.getXMLContent(testAccession);
    //var dataStr = "";
    var downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", `${testAccession.LabNumber}.xml`);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  downloadCSV(testAccession: TestAccession) {
    var dataStr = "data:text/csv;charset=utf-8," + (testAccession.Title + " " + testAccession.ForeName + " " + testAccession.Surname + "," + testAccession.Dob + "," + testAccession.RequestDate + "," + testAccession.LabNumber + "," + testAccession.Sex + "," + testAccession.AttendingDr + "," + testAccession.SampleDate + "," + testAccession.ReportedDate + "\r\n").trim();
    dataStr += testAccession.Tests.map(t => t.TestName + "\r\n" + t.ResultLines.map(r => r.TestName + "," + r.Result.replace(/(?:\r\n|\r|\n)/g, ' ')).join("\r\n")).join("\r\n");
    var downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", `${testAccession.LabNumber}.csv`);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  downloadJSON(testAccession: TestAccession) {
    var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(testAccession));
    var downloadAnchorNode = document.createElement('a');
    downloadAnchorNode.setAttribute("href", dataStr);
    downloadAnchorNode.setAttribute("download", `${testAccession.LabNumber}.json`);
    document.body.appendChild(downloadAnchorNode); // required for firefox
    downloadAnchorNode.click();
    downloadAnchorNode.remove();
  }

  getXMLContent(testAccession: TestAccession) {
    var dataStr = "data:text/xml;charset=utf-8,<TestAccession>";
    dataStr += "<Name>" + (testAccession.Title + " " + testAccession.ForeName + " " + testAccession.Surname).trim() + "</Name>";
    dataStr += "<DOB>" + testAccession.Dob + "</DOB>";
    dataStr += "<RequestDate>" + testAccession.RequestDate + "</RequestDate>";
    dataStr += "<LabNo>" + testAccession.LabNumber + "</LabNo>";
    dataStr += "<Sex>" + testAccession.Sex + "</Sex>";
    dataStr += "<AttendingDr>" + testAccession.AttendingDr + "</AttendingDr>";
    dataStr += "<SampleDate>" + testAccession.SampleDate + "</SampleDate>";
    dataStr += "<ReportDate>" + testAccession.ReportedDate + "</ReportDate>";
    dataStr += "<Tests>";
    testAccession.Tests.forEach(function (test) {
      dataStr += "<TestResult><TestCode>" + test.TestCode + "</TestCode><TestName>" + test.TestName + "</TestName>";
      test.ResultLines.forEach(function (resultline) {
        dataStr += "<Result>";
        dataStr += "<TestCode>" + resultline.TestCode + "</TestCode>";
        dataStr += "<TestName>" + resultline.TestName + "</TestName>";
        dataStr += "<Resultline>" + resultline.Result.replace(/(?:\r\n|\r|\n)/g, ' ') + "</Resultline>";
        dataStr += "</Result>";
      })
      dataStr += "</TestResult>";
    });
    dataStr += "</Tests>";
    console.log(dataStr)
    return dataStr;
  }

  ngOnInit() {
    //console.log('details init');
    this.UserSource = this.authService.getLoginSource() || new Source();
    this.cumClicked = false;
    this.cumShouldBeEmpty = true;
  }
}
